import { sanitize } from "isomorphic-dompurify";


interface Props {
  content: string;
  sanitizeContent?: boolean;
  className?: string;
}

export default function HTMLRenderer({ content, className, sanitizeContent = false }: Props) {
  return <div dangerouslySetInnerHTML={{ __html: sanitizeContent ? sanitize(content) : content }} className={className} />
}